const browsers: [RegExp, string][] = [
    [/^voxie\/mh-lite\b/, 'Voxie app'],
    [/\bEdg(?:e|A|iOS)?\/\d/, 'Edge'],
    [/\bOPR\/\d|\bOpera\b/, 'Opera'],
    [/\bSamsungBrowser\/\d/, 'Samsung Internet'],
    [/\bFirefox\/\d|\bFxiOS\/\d/, 'Firefox'],
    [/\bChrome\/\d|\bCriOS\/\d/, 'Chrome'],
    [/\bVersion\/\d[\d.]*.*\bSafari\/\d/, 'Safari'],
];

const systems: [RegExp, string][] = [
    [/\biPhone\b|\biPod\b|\biOS\/\d/, 'iOS'],
    [/\biPad\b|\biPadOS\/\d/, 'iPadOS'],
    [/\bAndroid\b/, 'Android'],
    [/\bWindows\b/, 'Windows'],
    [/\bCrOS\b/, 'ChromeOS'],
    [/\bMac OS X\b|\bMacintosh\b/, 'macOS'],
    [/\bLinux\b/, 'Linux'],
];

const labelFor = (patterns: [RegExp, string][], userAgent: string): string | undefined =>
    patterns.find(([pattern]) => pattern.test(userAgent))?.[1];

export const userAgentLabel = (userAgent: string | null | undefined): string => {
    if (!userAgent) {
        return '-';
    }

    const browser = labelFor(browsers, userAgent) ?? 'Unknown browser';
    const system = labelFor(systems, userAgent);

    return system ? `${browser} · ${system}` : browser;
};
